import React, { useState } from "react";
import NoData from "../../../../../components/noData/noData";
import CommonTable from "../../../../../components/table/table";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import { Icons } from "../../../../../../utils/icons";
import BottomDrawer from "../../../../common/drawer/bottomDrawer";
import CommonForm from "../../../../../components/form/form";
import useCommonFetch from "../../../../../../hooks/useCommonFetch";
import {
  createDocument,
  updateDocument,
  deleteDocument,
  getDocumentList,
} from "../../../../../../services/workspace/user.service";



const DocumentCard = ({ staff, heandleFetchData }) => {
  const [isOpenSheet, setIsOpenSheet] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [documentData, setDocumentData] = useState([]);

  const documents = staff?.documents || [];
  const { handleCreate, handleUpdate, handleDelete } = useCommonFetch();

  const TableHeaderData = [
    { label: "Document Name", key: "document_name" },
    { label: "Document Number", key: "document_number" },
    { label: "Expiry Date", key: "expiry_date" },
    { label: "Uploaded Date", key: "uploaded_date" },
    { label: "Uploaded By", key: "uploaded_by" },
    { label: "Document", key: "documents" },
    // { label: "Status", key: "status" },
  ];

  const tableData = documents.map((item) => ({
    document_name: { data: item?.name, variant: "text" },
    document_number: { data: item?.data?.document_number, variant: "text" },
    expiry_date: { data: item?.data?.expiry_at, variant: "date" },
    uploaded_date: { data: item?.created_at, variant: "date" },
    uploaded_by: { data: item?.createdBy?.name, variant: "text" },
    status: {
      data: item?.status,
      className: "",
      sticky: false,
      variant: "status",
    },
    id: { data: item.id, variant: "text" },
    uuid: { data: item.uuid, variant: "text" },
    actions: { data: item.id, variant: "text" },
    documents: { data: item.documents, variant: "image" },
    
  }));

  const actionButton = {
    edit: (item) => handleEdit(item),
    delete: async (item) => {
      await handleDelete(item?.uuid?.data || item, deleteDocument, {
        successMessage: "Experience deleted successfully!",
        errorMessage: "Failed to delete experience!",
      });
      heandleFetchData();
    },
  };

  const handleEdit = (item) => {
    const initialData = {
      id: item.id.data,
      uuid: item.uuid.data,
      documentName: item.document_name.data || "",
      documentNumber: item.document_number.data || "",
      expiryDate: item.expiry_date.data || "",
      documents: item.documents ? [item.documents] : [],
    };
    setCurrentRecord(initialData);
    setIsEditMode(true);

    setIsOpenSheet(true);
  };

  // Form fields
  const formFields = [
    {
      name: "documentName",
      type: "text",
      label: "Document Name",
      placeholder: "Enter here",
      required: true,
      colSpan: 6,
    },
    {
      name: "documentNumber",
      type: "text",
      label: "Document Number",
      placeholder: "Enter here",
      required: true,
      colSpan: 6,
    },
    {
      name: "expiryDate",
      type: "date",
      label: "Expiry Date",
      placeholder: "Select",
      colSpan: 6,
    },

    {
      name: "documents",
      type: "file",
      label: "Upload Files",
      placeholder: "Choose files",
      accept: ["pdf", "doc", "docx", "jpg", "png"],
      limit: 5,
      // Staff documents ko master API par upload karne ke liye
      useMasterApi: true,
      // folder: "user-documents",
      colSpan: 12,
    },
  ];

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // Extract final file paths/URLs from uploader response, same pattern as existing frontend implementation
    const documentUrls =
      values.documents
        ?.filter(
          (file) => file.uploadUrl || file.path || file.serverResponse
        )
        ?.map((file) => {
          // Prefer server response URL/path if available, else fall back to uploadUrl/path
          if (file.serverResponse?.url) {
            return file.serverResponse.url;
          } else if (file.serverResponse?.path) {
            return file.serverResponse.path;
          } else if (file.uploadUrl) {
            return file.uploadUrl;
          } else if (file.path) {
            return file.path;
          }
          return null;
        })
        ?.filter((url) => url !== null) || [];

    const payload = {
      id: staff.id,
      name: values.documentName,
      data: {
        document_number: values.documentNumber,
        expiry_at: values.expiryDate || null,
      },
      // API ko sirf file path/URL ki array milegi, e.g. ['path']
      documents: documentUrls,
      collection_name: "user-docs",
    };

    try {
      if (isEditMode && currentRecord?.uuid) {
        await handleUpdate(payload, currentRecord.uuid, updateDocument, {
          successMessage: "Document updated successfully!",
          errorMessage: "Failed to update document!",
        });
        heandleFetchData();
      } else {
        await handleCreate(payload, createDocument, {
          successMessage: "Document created successfully!",
          errorMessage: "Failed to create document!",
        });
        heandleFetchData();
      }

      const updatedList = await getDocumentList({ user_id: staff.id });
      setDocumentData(updatedList);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    } finally {
      setSubmitting(false);
      setTimeout(() => {
        resetForm();
        setIsEditMode(false);
        setCurrentRecord(null);
        setIsOpenSheet(false);
      });
    }
  };

  const handleCancel = () => {
    setIsEditMode(false);
    setCurrentRecord(null);
    setIsOpenSheet(false);
  };

  return (
    <div className="flex flex-col bg-white rounded-md h-full">
      {tableData.length > 0 ? (
        <div>
          <div className="border-b flex justify-between p-4">
            <h2 className="text-lg font-semibold text-blue-900">
              Documents Details
            </h2>
            <DefaultButton
              name={Icons.ADD}
              onClick={() => setIsOpenSheet(true)}
            />
          </div>
          <div className="p-4">
            <CommonTable
              TableHeaderData={TableHeaderData}
              tabledata={tableData}
              loading={false}
              action={actionButton}
            />
          </div>
        </div>
      ) : (
        <NoData
          title="No Result Found"
          message="Please add documents"
          buttonText="Add Document"
          onClick={() => setIsOpenSheet(true)}
        />
      )}

      <BottomDrawer
        classNames={"!w-[500px]"}
        title={isEditMode ? "Edit Document" : "Upload Document"}
        isOpen={isOpenSheet}
        setIsOpen={handleCancel}
        position="right"
      >
        <CommonForm
          fields={formFields}
          initialData={currentRecord || {}}
          onSubmit={handleSubmit}
          submitButtonText={isEditMode ? "Update" : "Submit"}
          onCancel={handleCancel}
          cancelButtonText="Cancel"
          columnsPerRow={2}
        />
      </BottomDrawer>
    </div>
  );
};

export default DocumentCard;
